'use client';

import { Description, Dialog, DialogPanel } from '@headlessui/react';
import { useEffect, useState } from 'react';

type ModalProps = {
  modal: {
    modalImage: {
      node: {
        sourceUrl: string;
      };
    };
    modalLink: {
      url: string;
    };
  };
};

export function Modal({ modal }: ModalProps) {
  const [isOpen, setIsOpen] = useState(false);

  const modalImage = modal?.modalImage?.node?.sourceUrl ?? '';
  const modalTarget = modal?.modalLink?.url ?? '';

  useEffect(() => {
    // get isModalDismissed from cookie
    const isModalDismissed = document.cookie.includes('isModalDismissed=true');

    if (!isModalDismissed) {
      // Set a timer to open the modal after 5 seconds
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 3000);

      // Clear the timer if the component is unmounted
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    // set cookie, expires 3 days
    const days = 3;
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      'isModalDismissed=true; expires=' + d.toUTCString() + '; path=/';
  };

  return (
    <Dialog open={isOpen} onClose={() => {}}>
      <div
        className="fixed inset-0 z-300 flex items-center justify-center bg-black bg-opacity-50 lg:items-start"
        onClick={handleClose}
      >
        <DialogPanel className="relative max-w-[90%] rounded bg-white lg:mt-[90px] lg:max-w-full">
          <Description className="m-0">
            <a href={modalTarget} onClick={handleClose}>
              <img src={modalImage} className="rounded" alt="" />
            </a>
          </Description>
          <button
            onClick={handleClose}
            className="absolute right-[5px] top-[5px] rounded border border-[#7a7a7a] bg-white p-[9px]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
            >
              <path
                d="M0.587891 0.587891L4.99966 4.99966M9.41142 9.41142L4.99966 4.99966M4.99966 4.99966L9.41142 0.587891M4.99966 4.99966L0.587891 9.41142"
                stroke="#626262"
                strokeWidth="0.882353"
              />
            </svg>
          </button>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
